// Generated types for MainPortExtractionTask
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { EntityExtractionTaskReadAPI, EntityExtractionTaskWriteAPI } from './entityextractiontask';
import { EntityExtractionTaskReadAPISchemaObject, EntityExtractionTaskWriteAPISchemaObject } from './entityextractiontask';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface MainPortExtractionTaskReadAPI extends EntityExtractionTaskReadAPI {
}

export interface MainPortExtractionTaskWriteAPI extends EntityExtractionTaskWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const MainPortExtractionTaskReadAPISchema: z.ZodType<MainPortExtractionTaskReadAPI> = EntityExtractionTaskReadAPISchemaObject.extend({}).passthrough();

export const MainPortExtractionTaskWriteAPISchema: z.ZodType<MainPortExtractionTaskWriteAPI> = EntityExtractionTaskWriteAPISchemaObject.extend({}).passthrough();
